import { Outlet, Link } from 'react-router';

export function AnonymousLayout() {
  return (
    <div className="min-h-screen bg-[#FAFAFB]" style={{ fontFamily: '"Lato", "Source Sans Pro", sans-serif' }}>
      <header className="bg-white" style={{ boxShadow: 'inset 0px -1px 0px #E2E2EA', borderBottom: '1px solid rgba(226,226,234,0.5)' }}>
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <Link to="/" className="flex-shrink-0">
              <img src="/assets/logo.png" alt="Connectfy" className="w-[200px]" />
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/login" className="text-sm text-[#767676] hover:text-[#111]">
                Sign In
              </Link>
              <Link
                to="/signup"
                className="text-sm bg-[#cc0404] text-white px-4 py-2 rounded-[4px] hover:bg-[#a30303]"
              >
                Sign Up
              </Link>
            </div>
          </div>
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
      <footer className="bg-white border-t" style={{ borderColor: 'rgba(226,226,234,0.5)' }}>
        <div className="max-w-7xl mx-auto px-4 py-6 text-center text-sm text-[#767676]">
          <Link to="/privacy" className="hover:text-[#111]">Privacy Policy</Link>
          <span className="mx-2">·</span>
          <Link to="/help/contact" className="hover:text-[#111]">Contact Us</Link>
          <span className="mx-2">·</span>
          <span>© {new Date().getFullYear()} Kiwi Systems Ltd</span>
        </div>
      </footer>
    </div>
  );
}
